import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Controls from '../common/controls'

export default class Questionnaire2 extends Component {
  constructor(props) {
    super(props)
    this.next = this._next.bind(this)
    document.title = "Personality Type"
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    window.scrollTo(0, 0)
  }

  _next() {
    return this.props.next(this.props.match.path)
  }

  renderPersonalityType() {
    switch(this.props.personalityType) {
      case 'E':
        return (
          <div>
            <h3>Emotion Based</h3>
            <p>Whether you are feeling positive or negative emotions, you may turn to food for comfort, as a means of distraction, or even in celebration.</p>
            <p>During these times, you may find yourself reaching for foods that are high in sugar, fat or salt. While these foods may make you feel better at the time; the feeling doesn’t last. Instead you are left to deal with the original emotion or stressful situation, as well as any feelings of regret or guilt about over-indulging.</p>
            <p>Like a trusted friend, your certified coach will support you and help you manage your emotions and stress in more productive ways.</p>
          </div>
        )
      case 'O':
        return (
          <div>
            <h3>Opportunity Based</h3>
            <p>Because your pace and lifestyle is fast, you may find yourself grabbing food on the go, and unconsciously grazing on food throughout the day. You may also find you eat faster than everyone else at the table; making it easy to go back for seconds or even thirds! This can lead to mindless eating and leave you feeling disconnected from your true sense of hunger.</p>
            <p>Eating when you are not truly hungry can also cause you to gain weight, as you lose track of how many additional calories you are consuming each day.</p>
            <p>Like a trusted friend, your certified coach will support you and help you get in touch with your true hunger and show you how to eat mindfully.</p>
          </div>
        )
      case 'A':
        return (
          <div>
            <h3>All-Or-Nothing Based</h3>
            <p>You can often find it challenging to stick to a diet or exercise plan because of difficulties with planning or because you bite off more than you can chew!</p>
            <p>While you may initially feel motivated to start working towards your healthy lifestyle goals, it can be hard to stay on track without structure and some level of accountability. This means that minor setbacks — like one day of bad eating — can derail you completely.</p>
            <p>Like a trusted friend, your certified coach will help you add structure to your day and keep you motivated and accountable; with a blueprint to help you achieve your goals—one step at a time.</p>
          </div>
        )
      default: break
    }
  }

  render() {
    return (
      <div id="questionnaire_2">
        <AriaMessage message="Navigated to questionnaire result page" />
        <Title>My Personality Type</Title>
        <div className="container">
          <h2>Here is what we have learned about you so far...</h2>
          <div className="personality-block">
            <div className="personality-image-block">
              <img className="personality-image" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/f1e521f6-d22a-4fd3-9d0e-d57674c0aba5.png" alt="heart in a speech bubble"></img>
            </div>
            <div className="personality-text-block">
              {this.renderPersonalityType()}
            </div>
          </div>
          <h3 className="personality-header">Now that we know you better, it’s time to meet the Inspirator that we’ve matched you with! Click below to schedule your first call and be on your way to achieve the results you’re looking for!</h3>
          <Controls dataAtId="questionnaire_p2" next={this.next} nextLabel="SCHEDULE MY COACHING SESSION" className="schedule" />
        </div>
      </div>
    )
  }
}